import React, { Component } from "react";
import cn from "classnames";
import { Divider } from "shared/layout";
import config from "../config";
import styles from "./styles.css";
import Link from "./Link";
import LinkIcon from "./LinkIcon";
import Submenu from "./Submenu";
import UserHeader from "./UserHeader";
import UserMenu from "./UserMenu";

export default class Mobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expandedId: "",
    };
  }

  toggleMenu = (event) => {
    const { expandedId } = this.state;
    const targetId = event.currentTarget.getAttribute("aria-controls");

    event.preventDefault();

    this.setState({
      expandedId: targetId === expandedId ? "" : targetId,
    });
  };

  render() {
    const { className, ...rest } = this.props;
    const { expandedId } = this.state;
    const navigationItems = config.baseMenu.items;

    return (
      <nav
        {...rest}
        className={cn(styles.navigation, className)}
        role="navigation"
      >
        <UserHeader />

        <ul>
          {navigationItems.map((item) => {
            const id = `${item.title.toLowerCase()}-menu-mobile`;
            const label = `${item.title.toLowerCase()}-heading-mobile`;

            return (
              <li key={item.title} className={styles.item} id={label}>
                {!item.submenu && <Link href={item.url}>{item.title}</Link>}

                {item.submenu && (
                  <Link
                    href={item.url}
                    onClick={this.toggleMenu}
                    aria-controls={id}
                    id={label}
                  >
                    {item.title}

                    <LinkIcon expanded={id === expandedId} />
                  </Link>
                )}

                {item.submenu &&
                  item.submenu.items.length > 0 && (
                    <Submenu
                      id={id}
                      hidden={id !== expandedId}
                      aria-expanded={id === expandedId}
                      items={item.submenu.items}
                      featured={item.submenu.featured}
                      aria-labelledby={label}
                    />
                  )}
              </li>
            );
          })}
        </ul>

        <Divider className={styles.divider} />

        <UserMenu />
      </nav>
    );
  }
}
